import { useLocation } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_conversion-labs-6/artifacts/qzhea8b5_WhatsApp%20Image%202026-04-23%20at%2010.14.46%20AM.jpeg";

export default function Navbar({ onCTA }) {
  const { pathname } = useLocation();
  const isActive = (path) => {
    if (path === "/") return pathname === "/" || pathname === "/home";
    if (path === "/services") {
      // Highlight Services for /services and /services/* — except the standalone AI Ads page
      return pathname === "/services" || (pathname.startsWith("/services/") && pathname !== "/services/ai-ads");
    }
    if (path === "/services/ai-ads") return pathname === "/services/ai-ads" || pathname === "/ai-ads";
    return pathname === path;
  };

  const linkBase =
    "relative text-sm transition-colors after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:rounded-full after:transition-all";
  const linkInactive = "text-slate-300 hover:text-white after:w-0 after:bg-blue-400";
  const linkActive = "text-white after:w-full after:bg-blue-400";

  const navLink = (path) =>
    `${linkBase} ${isActive(path) ? linkActive : linkInactive}`;

  return (
    <header
      className="relative z-40 border-b border-white/5 bg-slate-950/80 backdrop-blur-xl"
      data-testid="site-navbar"
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 md:px-6">
        <a href="/" className="flex items-center" data-testid="navbar-logo">
          <img
            src={LOGO_URL}
            alt="Markite"
            className="h-10 w-auto ring-1 ring-white/10"
            data-testid="navbar-logo-img"
          />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          <a href="/" className={navLink("/")} data-testid="nav-home" aria-current={isActive("/") ? "page" : undefined}>
            Home
          </a>
          <a href="/services" className={navLink("/services")} data-testid="nav-services" aria-current={isActive("/services") ? "page" : undefined}>
            Services
          </a>
          <a href="/pricing" className={navLink("/pricing")} data-testid="nav-pricing" aria-current={isActive("/pricing") ? "page" : undefined}>
            Pricing
          </a>
          <a href="/clients" className={navLink("/clients")} data-testid="nav-clients" aria-current={isActive("/clients") ? "page" : undefined}>
            Clients
          </a>
          <a href="/services/ai-ads" className={navLink("/services/ai-ads")} data-testid="nav-ai-ads" aria-current={pathname === "/services/ai-ads" ? "page" : undefined}>
            AI Ads
          </a>
        </nav>

        <button
          type="button"
          onClick={onCTA}
          className="btn-primary inline-flex h-10 items-center rounded-full px-5 text-sm font-semibold text-white"
          data-testid="navbar-cta-btn"
        >
          Get Started
        </button>
      </div>
    </header>
  );
}
